<template>
  <div>
    <div class="wrapping_holder">
      <vs-card class="cstm-vx-card">
        <form :class="[$route.path.includes('questions-builder') ? 'question_builder_holder' : 'w-full']" data-vv-scope="Questions">
          <div class="each_card">          
            <h4 class="mb-4">New Template</h4>
            <div class="grey_border p-4 mb-4">
              <assignment-header
                v-model="assignment_header_info"
              ></assignment-header>

              <!-- Subject Component -->
              <subject-component
                v-model="subject_id"
                :has_all_subject="has_all_subject"
                :subjectDisabled="subjectDisabled"
                validatorScope="Questions"
                ref="childSubjectComponent"
                @allSub="allSub"
              ></subject-component>
            </div>
          </div>

          <div class="each_card">  
            <!-- Subject Component -->
            <!-- right most action sidebar -->
            <div class="flex flex-wrap justify-between items-center my-2">
              <h4>Questions</h4>
              <div class="inline-flex">
                <a href="#" class="block mr-3" @click.prevent="addNewQuestionForm">
                  <vs-tooltip
                    text="Add New Question"
                    position="right"
                    class="option-tooltip"
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 27.88 27.88"
                    >
                      <circle class="cls-1" cx="13.94" cy="13.94" r="12.94" />
                      <line
                        class="cls-1"
                        x1="13.94"
                        y1="8.45"
                        x2="13.94"
                        y2="19.43"
                      />
                      <line
                        class="cls-1"
                        x1="8.45"
                        y1="13.94"
                        x2="19.43"
                        y2="13.94"
                      />
                    </svg>
                  </vs-tooltip>
                </a>

                <!-- {{ isQuestionModal }} -->
                <a
                  href="#"
                  class="block"
                  @click.prevent="isQuestionModal = !isQuestionModal"
                  v-if="$route.path.includes('questions-builder')"
                >
                  <vs-tooltip
                    text="Import Question"
                    position="right"
                    class="option-tooltip"
                  >
                    <svg
                      id="Layer_1"
                      data-name="Layer 1"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 30.84 27.34"
                    >
                      <polyline
                        class="cls-1"
                        points="5.92 22.91 5.92 26.34 29.84 26.34 29.84 1 5.92 1 5.92 15.61"
                      />
                      <line class="cls-1" x1="11" y1="5.72" x2="24.8" y2="5.72" />
                      <line class="cls-1" x1="11" y1="9.72" x2="19.14" y2="9.72" />
                      <line class="cls-1" x1="1" y1="19.72" x2="14.8" y2="19.72" />
                      <polyline
                        class="cls-2"
                        points="10.85 15.06 15.18 19.39 10.85 23.72"
                      />
                    </svg>
                  </vs-tooltip>
                </a>
              </div>
            </div>

            <div style="max-height: 300px; overflow: auto;" class="vertical_scrollbar pr-2">
              <vs-collapse class="question_card">
                <draggable
                  :list="question_details"
                  class="py-2 cursor-move"
                  handle=".handle1"
                >              
                  <vs-collapse-item v-for="(question_detail, index) in question_details"
                  :key="index"
                  class="relative">
                    <div class="header" slot="header">    
                      <div class="drag_holder handle1">
                        <span class="material-icons-outlined">drag_indicator</span>
                      </div>
                      <h5>Question {{ index + 1 }}</h5>
                    </div>

                    <div class="content" v-if="question_detail.showAnswer === false">
                      <!-- question setting area -->
                      <vs-row vs-w="12">
                        <!-- question -->
                        <vs-col vs-justify="center" vs-align="top" vs-lg="6" vs-xs="12">
                          <div class="bg-grid-color flex selectable-holder w-full">
                            <!-- <vs-input class="inputx w-full mr-2" placeholder="Question" v-model="question_detail.question_title" /> -->
                            <vs-textarea
                              v-model="question_detail.question_title"
                              label="Type The Question"
                              v-validate="'required'"
                              :name="`Question`"
                            ></vs-textarea>
                          </div>

                          <span
                            v-show="errors.has(`Questions.Question`)"
                            class="text-danger block"
                            >{{ errors.first(`Questions.Question`) }}</span
                          >
                        </vs-col>

                        <vs-col
                          class="pl-0 sm:pl-2"
                          vs-justify="center"
                          vs-align="top"
                          vs-lg="6"
                          vs-xs="12"
                        >
                          <div class="bg-grid-color flex w-full">
                            <!-- {{input_field_type}} -->
                            <!-- {{question_detail}} -->
                            <!-- {{ assignment_type }} -->
                            <v-select
                              class="w-full"
                              v-validate="'required'"
                              :options="input_field_type"
                              label="label"
                              v-model="question_detail.input_type_id_obj"
                              @input="changeType(question_detail)"
                              :clearable="false"
                              :name="`Question Type`"
                              :data-vv-name="`Question Type`"
                              placeholder="Select Question Type"
                              v-bind:class="{
                                disabled: question_detail.id != null ? true : false,
                              }"
                              :selectable="
                                (option) =>
                                  parseInt(assignment_type) === 3 ||
                                  assignment_type === 'Report'
                                    ? !option.field_type.includes('fileupload')
                                    : option
                              "
                            ></v-select>
                          </div>
                          <span
                            v-show="errors.has(`Questions.Question Type`)"
                            class="text-danger block"
                            >{{ errors.first(`Questions.Question Type`) }}</span
                          >
                        </vs-col>
                        <!-- end of question -->
                      </vs-row>
                      <vs-divider />
                      <!-- End of FileUpload on question type file upload selected -->

                      <!-- mcq options area -->
                      <div
                        class="options-holder"
                        v-if="
                          ['radio', 'checkbox', 'select', 'multiselect'].includes(
                            question_detail.input_type_id_obj.field_type
                          )
                        "
                      >
                        <draggable
                          :list="question_detail.option"
                          class="py-2 cursor-move"
                          handle=".handle2"
                        >
                          <div
                            class="w-full mb-4"
                            v-for="(eachOption, counter) in question_detail.option"
                            :key="counter"
                          >
                            <div class="flex items-center w-full">
                              <span
                                style="color: #c1c1c1"
                                class="material-icons-outlined handle2"
                                >drag_indicator</span
                              >
                              <vs-input
                                class="inputx w-full mx-2"
                                placeholder="Option"
                                v-model="eachOption.option_name"
                              />
                              <vs-button
                                v-if="counter !== 0"
                                color="danger"
                                type="filled"
                                icon-pack="feather"
                                icon="icon-x"
                                @click.prevent="removeOption(question_detail, counter)"
                              ></vs-button>
                            </div>
                          </div>
                        </draggable>

                        <div class="vx-col sm:w-1/2 w-full mb-4">
                          <a
                            class="text-primary font-bold text-sm cursor-pointer"
                            @click.prevent="addnewOptions(question_detail)"
                            >Add Another Option</a
                          >
                        </div>
                      </div>
                      <!-- end of mcq options area -->
                      <div class="flex flex-wrap justify-between items-center">
                        <div class="inline-flex items-center">
                          <a
                            class="cstm-primary-anchor cursor-pointer"
                            @click.prevent="toggleAnswer(question_detail)"
                          >
                            <svg
                              id="Layer_1"
                              data-name="Layer 1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 19.84 24.82"
                            >
                              <rect
                                class="cls-1"
                                x="1"
                                y="4.92"
                                width="17.84"
                                height="18.89"
                              />
                              <path
                                class="cls-1"
                                d="M8.85,4.06a3.88,3.88,0,1,1,7.76,0"
                                transform="translate(-2.81 0.82)"
                              />
                              <line
                                class="cls-1"
                                x1="4.79"
                                y1="19.62"
                                x2="15.08"
                                y2="19.62"
                              />
                              <polyline
                                class="cls-1"
                                points="6.04 12.53 8.39 15.96 15.05 10.7"
                              />
                            </svg>
                            <span class="ml-2 font-bold">Answer Key</span>
                          </a>
                          <div style="border: none;" class="num-holder">
                            Point {{ question_detail.point }}
                          </div>
                        </div>
                        <div>
                          <div class="cstm-action-holder">
                            <vs-tooltip
                              text="Duplicate Question"
                              class="option-tooltip"
                            >
                              <a
                                class="cursor-pointer"
                                @click="duplicate(question_detail)"
                              >
                                <svg
                                  id="Layer_1"
                                  data-name="Layer 1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 19.75 23.95"
                                >
                                  <rect
                                    class="cls-1"
                                    x="5.32"
                                    y="1"
                                    width="13.43"
                                    height="17.5"
                                  />
                                  <polyline
                                    class="cls-1"
                                    points="1 8.95 1 22.95 11.91 22.95"
                                  />
                                </svg>
                              </a>
                            </vs-tooltip>

                            <!------------ File Upload Icon Start ------------>
                            <!-- Image Upload -->
                            <vs-tooltip text="Upload Image" class="option-tooltip">
                              <a
                                class="cursor-pointer"
                                @click="
                                  question_detail.showFileUpload = true;
                                  question_detail.showLinkUpload = false;
                                  question_detail.acceptedfileUploadType = 'image/*';
                                  question_detail.fileUploadHelpText =
                                    'Choose Image files';
                                "
                              >
                                <svg
                                  class="cls-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#000000"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <rect
                                    class="cls-1"
                                    x="3"
                                    y="3"
                                    width="18"
                                    height="18"
                                    rx="2"
                                  />
                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                  <path d="M20.4 14.5L16 10 4 20" />
                                </svg>
                              </a>
                            </vs-tooltip>

                            <!-- Video Upload -->
                            <vs-tooltip
                              text="Upload Audio/Video"
                              class="option-tooltip"
                            >
                              <a
                                class="cursor-pointer"
                                @click="
                                  question_detail.showFileUpload = true;
                                  question_detail.showLinkUpload = false;
                                  question_detail.acceptedfileUploadType =
                                    'audio/*,video/*';
                                  question_detail.fileUploadHelpText =
                                    'Choose Audio/Video files';
                                "
                              >
                                <svg
                                  class="cls-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#000000"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path
                                    d="M15.6 11.6L22 7v10l-6.4-4.5v-1zM4 5h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2z"
                                  />
                                </svg>
                              </a>
                            </vs-tooltip>

                            <!-- File Attachment -->
                            <vs-tooltip text="File Attachment" class="option-tooltip">
                              <a
                                class="cursor-pointer"
                                @click="
                                  question_detail.showFileUpload = true;
                                  question_detail.showLinkUpload = false;
                                  question_detail.acceptedfileUploadType = '';
                                  question_detail.fileUploadHelpText =
                                    'Choose Any files';
                                "
                              >
                                <svg
                                  class="cls-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#000000"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path
                                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                                  ></path>
                                </svg>
                              </a>
                            </vs-tooltip>
                            <!---------- File Upload Icon End ------------>

                            <!---------- Link Upload Icon Start ------------>
                            <vs-tooltip text="Add Links" class="option-tooltip">
                              <a
                                class="cursor-pointer"
                                @click="
                                  toggleLinkUpload(
                                    question_detail,
                                    question_detail.showLinkUpload
                                  )
                                "
                              >
                                <svg
                                  class="cls-1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#000000"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path
                                    d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                                  ></path>
                                  <path
                                    d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                                  ></path>
                                </svg>
                              </a>
                            </vs-tooltip>
                            <!---------- Link Upload Icon End ------------>

                            <!-- <pre> {{question_detail}}</pre> -->
                            <vs-tooltip text="Delete Question" class="option-tooltip">
                              <a
                                v-if="question_detail.id"
                                class="cursor-pointer"
                                @click="deleteQuestionById(question_detail.id, index)"
                              >
                                <svg
                                  id="Layer_1"
                                  data-name="Layer 1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 21.78 23.98"
                                >
                                  <polyline
                                    class="cls-1"
                                    points="1 5.4 3.2 5.4 20.78 5.4"
                                  />
                                  <path
                                    class="cls-1"
                                    d="M18.8,4.42V19.8A2.19,2.19,0,0,1,16.6,22h-11a2.19,2.19,0,0,1-2.19-2.2V4.42m3.29,0V2.22A2.2,2.2,0,0,1,8.91,0h4.4a2.2,2.2,0,0,1,2.2,2.2v2.2"
                                    transform="translate(-0.22 0.98)"
                                  />
                                  <line
                                    class="cls-1"
                                    x1="8.69"
                                    y1="10.89"
                                    x2="8.69"
                                    y2="17.48"
                                  />
                                  <line
                                    class="cls-1"
                                    x1="13.09"
                                    y1="10.89"
                                    x2="13.09"
                                    y2="17.48"
                                  />
                                </svg>
                              </a>

                              <a
                                v-else
                                class="cursor-pointer"
                                @click="deleteQuestion(index)"
                              >
                                <svg
                                  id="Layer_1"
                                  data-name="Layer 1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 21.78 23.98"
                                >
                                  <polyline
                                    class="cls-1"
                                    points="1 5.4 3.2 5.4 20.78 5.4"
                                  />
                                  <path
                                    class="cls-1"
                                    d="M18.8,4.42V19.8A2.19,2.19,0,0,1,16.6,22h-11a2.19,2.19,0,0,1-2.19-2.2V4.42m3.29,0V2.22A2.2,2.2,0,0,1,8.91,0h4.4a2.2,2.2,0,0,1,2.2,2.2v2.2"
                                    transform="translate(-0.22 0.98)"
                                  />
                                  <line
                                    class="cls-1"
                                    x1="8.69"
                                    y1="10.89"
                                    x2="8.69"
                                    y2="17.48"
                                  />
                                  <line
                                    class="cls-1"
                                    x1="13.09"
                                    y1="10.89"
                                    x2="13.09"
                                    y2="17.48"
                                  />
                                </svg>
                              </a>
                            </vs-tooltip>
                          </div>
                        </div>
                      </div>

                      <vs-row v-if="question_detail.showFileUpload">
                        <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12">
                          <vs-divider />
                          <VueFileAgentComponent
                            :acceptedfileUploadType="
                              question_detail.acceptedfileUploadType
                            "
                            :question_detail_obj="question_detail"
                            :question_detail_index="index"
                            :helpText="question_detail.fileUploadHelpText"
                            @getFileId="getIdFile"
                            @hideFileUploader="question_detail.showFileUpload = false"
                            :file_repository_id="repository_id"
                            :filesInfo="question_detail.filesInfo"
                            @deletedIndex="deletedIndex"
                          >
                          </VueFileAgentComponent>
                        </vs-col>
                        <vs-divider
                          v-if="assignment_type != 'Q&A' && assignment_type != '1'"
                        />
                      </vs-row>

                      <vs-row v-if="question_detail.showLinkUpload">
                        <vs-divider />
                        <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12">
                          <LinkPreviewComponent
                            :question_detail="question_detail"
                            type="Create-Edit"
                            @removeLinkEvent="removeLink"
                          >
                          </LinkPreviewComponent>
                          <vs-divider />
                          <vs-button
                            color="primary"
                            type="filled"
                            icon="add"
                            @click="addAnotherLink(question_detail)"
                          >
                            <span>Add Another Link</span>
                          </vs-button>
                        </vs-col>
                        <vs-divider
                          v-if="assignment_type != 'Q&A' && assignment_type != '1'"
                        />
                      </vs-row>
                      <!-- end of question setting area -->
                    </div>

                    <!-- end of add question form -->
                    <!-- answer block -->
                    <div class="mt-5" v-else>
                      <h4 class="flex items-center">
                        <svg
                          id="Layer_1"
                          data-name="Layer 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 19.84 24.82"
                        >
                          <rect
                            x="1"
                            y="4.92"
                            width="17.84"
                            height="18.89"
                            class="cls-1"
                          ></rect>
                          <path
                            d="M8.85,4.06a3.88,3.88,0,1,1,7.76,0"
                            transform="translate(-2.81 0.82)"
                            class="cls-1"
                          ></path>
                          <line
                            x1="4.79"
                            y1="19.62"
                            x2="15.08"
                            y2="19.62"
                            class="cls-1"
                          ></line>
                          <polyline
                            points="6.04 12.53 8.39 15.96 15.05 10.7"
                            class="cls-1"
                          ></polyline>
                        </svg>
                        <span class="ml-3">Choose correct answer</span>
                      </h4>
                      <vs-divider />
                      <vs-row>
                        <vs-col vs-type="flex" vs-align="center" vs-w="12">
                          <h5>{{ question_detail.question_title }}</h5>
                        </vs-col>

                        <vs-divider v-if="question_detail.question_title !== ''" />
                        <vs-col vs-type="flex" vs-align="center" vs-w="12">
                          <!-- {{ question_detail.point }} -->
                          <vs-input-number
                            type="text"
                            v-model="question_detail.point"
                            v-validate="'required|numeric'"
                            name="marks"
                            data-vv-name="marks"
                          />
                          <span class="ml-2">Points</span>
                          <span
                            v-show="errors.has('Questions.marks')"
                            class="text-danger block"
                            >{{ errors.first("Questions.marks") }}</span
                          >
                          <br />
                          <!-- {{question_detail.marks}} -->
                        </vs-col>
                      </vs-row>
                      <!-- {{question_detail.option}}
                      {{question_detail.answer}} -->
                      <div>
                        <div
                          class="answer-holder mt-4"
                          v-for="(dynamicarray, counter) in question_detail.option"
                          :key="counter"
                        >
                          <vs-checkbox
                            v-if="
                              question_detail.input_type_id_obj.field_type ===
                                'multiselect' ||
                              question_detail.input_type_id_obj.field_type ===
                                'checkbox'
                            "
                            v-validate="'required'"
                            data-vv-name="answer_select"
                            name="answer_select"
                            class="mx-4 w-full"
                            v-model="dynamicarray.is_answer"
                          >
                            {{ dynamicarray.option_name }}
                          </vs-checkbox>

                          <vs-checkbox
                            v-if="
                              question_detail.input_type_id_obj.field_type ===
                                'radio' ||
                              question_detail.input_type_id_obj.field_type === 'select'
                            "
                            :disabled="dynamicarray.is_answer == true"
                            @change="
                              setDynamicRadioTrue(question_detail.option, counter)
                            "
                            :vs-value="dynamicarray.is_answer === 1"
                            v-model="dynamicarray.is_answer"
                          >
                            {{ dynamicarray.option_name }}</vs-checkbox
                          >

                          <!-- {{question_detail}} -->
                          <!-- {{index}} -->
                          <span
                            v-show="errors.has('Questions.answer_select')"
                            class="text-danger block"
                            >{{ errors.first("Questions.answer_select") }}</span
                          >
                          <!-- {{question_detail.answer.includes(dynamicarray) }} -->
                          <!-- {{ question_detail.answer }} -->
                        </div>
                      </div>
                      <div
                        v-if="
                          question_detail.input_type_id_obj.field_type ===
                            'short-answer' ||
                          question_detail.input_type_id_obj.field_type ===
                            'paragraph' ||
                          question_detail.input_type_id_obj.field_type === 'paragraph'
                        "
                      >
                        <vs-textarea
                          label="answer"
                          v-model="question_detail.answer"
                          placeholder="Enter Answer"
                          height="200"
                        ></vs-textarea>
                      </div>

                      <vs-divider />
                      <div class="text-right">
                        <vs-button @click.prevent="setShowAnswerFalse(question_detail)"
                          >Done</vs-button
                        >
                      </div>
                    </div>

                    <vs-divider />

                    <!-- {{question_detail.save_question_bank}} -->

                    <vs-checkbox
                      v-model="question_detail.save_question_bank"
                      >Save this to Question bank</vs-checkbox
                    >

                  <!-- <vs-button class="ml-2" type="filled">Save</vs-button> -->
                  </vs-collapse-item>
                </draggable>
              </vs-collapse>
            </div>
          </div>
        </form>

        <vs-divider />

        <vs-button
          class="block mx-auto my-4"
          type="filled"
          @click.prevent="saveQuestion(true)"
          v-if="assignment_id_to_edit"
          >Save As</vs-button
        >

        <vs-button
          class="block mx-auto my-4"
          type="filled"
          @click.prevent="saveQuestion(false)"
          >{{assignment_type==1?'Save':'Save Template'}}</vs-button
        > 
      </vs-card>
    </div>

    <!--import Modal -->
    <vs-popup
      v-if="isQuestionModal"
      fullscreen
      title="Import Questions"
      :active.sync="isQuestionModal"
    >
      <question-modal
        :subject_id="subject_id"
        @closeQuestionBank="closedBank"
      ></question-modal>
    </vs-popup>
  </div>
</template>

<script>
import { repository } from '@/mixins/repository'

import { Subject } from '@/mixins/subject/subject'
import { Tag } from '@/mixins/tag/tag'
import {
  createAssignment,
  editAssignment,
  deleteAssignmentQuestion
} from '@/api/assignment-question'

import { createQuestionBank, editQuestionBank } from '@/api/question-bank' //question_bank
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import QuestionModal from './question-modal.vue'

import VueFileAgentComponent from './components/filetesting.vue'
import AssignmentHeader from './components/AssignmentHeader.vue'
import QuestionDetails from './components/QuestionDetails.vue'

import LinkPreviewComponent from '@/components/LinkPreview/LinkPreviewComponent'
import SubjectComponent from '@/components/common/SubjectComponent'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { questionMixin } from './mixins/questionMixin'

export default {
  name: 'QuestionsV2',
  mixins: [Subject, Tag, PermissionMiddleware, repository, questionMixin],
  components: {
    draggable,
    vSelect,
    QuestionModal,
    VueFileAgentComponent,
    LinkPreviewComponent,
    SubjectComponent,
    AssignmentHeader,
    QuestionDetails
  },

  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.checkingAssignmentBuilder()
    }

    //Checking if redirected from any listing create button or not
    if (this.$route.params.redirection_from) {
      this.assignment_type = this.$route.params.redirection_from
      this.questionbank_type = this.$route.params.redirection_from
    } else if (this.$route.params.assignment_details) {
      this.subjectDisabled = true
      const assignment_details_to_edit = this.$route.params.assignment_details

      this.assignment_id_to_edit = assignment_details_to_edit.id
      this.questionbank_type =
        assignment_details_to_edit.assignment_type_obj.id
      this.assignment_type = assignment_details_to_edit.assignment_type
      this.platform_module_id =
        assignment_details_to_edit.assignment_type_obj.platform_module_id
      this.assignment_header_info.question_section_title =
        assignment_details_to_edit.title
      this.assignment_header_info.question_section_description =
        assignment_details_to_edit.description
      this.subject_id = assignment_details_to_edit.subject
      this.has_all_subject = assignment_details_to_edit.has_all_subject

      //tags//
      const tagsselected = assignment_details_to_edit.tags.map((tag) => {
        return tag.tag_id
      })
      this.tagSelected = tagsselected
      this.oldtagSelected = tagsselected

      //tags

      // this.questionbank_type = assignment_details_to_edit.assignment_type;

      this.question_details = this.setQuestionDetails(
        assignment_details_to_edit.questions
      )
    } else if (this.$route.params.question_details) {
      this.subjectDisabled = true

      //
      //
      const assignment_details_to_edit = this.$route.params.question_details

      this.assignment_id_to_edit = assignment_details_to_edit.id
      const assignment_type = 'Q&A'
      this.assignment_type = assignment_type
      this.question_section_title = assignment_details_to_edit.question_title

      this.question_section_description =
        assignment_details_to_edit.description
      this.subject_id = assignment_details_to_edit.subject
      this.has_all_subject = assignment_details_to_edit.has_all_subject

      this.question_details = []
      const each_question = assignment_details_to_edit
      if (each_question.links.length > 0) {
        this.showLinkUpload = true
      }
      const q = {
        id: each_question.id,
        files: each_question.file ? each_question.file : [],
        filesInfo: each_question.file,
        file_id: each_question.file.map((ele) => {
          return {
            id: ele.file_id,
            attachement: false
          }
        }),

        links:
          each_question.links.length > 0
            ? each_question.links.map((url) => {
              return url.url
            })
            : [''],
        input_type_id_obj: {
          id: each_question.input_type_id_obj.id,
          label: each_question.input_type_id_obj.label,
          field_type: each_question.input_type_id_obj.field_type
        },
        input_type_id: each_question.input_type_id,
        question_title: each_question.question_title,
        answer: each_question.answer,
        answerfeedback: each_question.answerfeedback,
        marks: 10000,
        option: each_question.option,
        point: each_question.point,
        showAnswer: false,
        ordering: each_question.ordering,
        showFileUpload: false,
        showLinkUpload: false,
        acceptedfileUploadType: 'image/*',
        fileUploadHelpText: 'Choose Image files'
      }

      const tagsselected = assignment_details_to_edit.tags.map((tag) => {
        return tag.tag_id
      })
      this.tagSelected = tagsselected

      this.question_details.push(q)

      this.platform_module_id = this.QUESTION_ANSWER_PLATFORM_MODULE_ID
    }

    this.getPLatformId()
  },
  mounted () {
    this.fetchQuestionInputType()
    this.fetchAssignmentTypes() //fetch tag after this function
  },

  data () {
    return {
      has_all_subject: true,
      questionLinksUpload: '',
      showLinkUpload: false,
      fileUploadHelpText: 'Choose images',
      showFileUpload: false,
      acceptedfileUploadType: 'image/* ',
      fileToUpload: '',
      assignment_type_hint: 'Q&A',
      assignment_details_to_edit: false,
      assignment_id_to_edit: false,
      isQuestionModal: false,
      assignment_type: 1,
      platform_module_id: '',
      subjectlist: [],
      subject_id: [],
      //addOption: 'addOption1',
      addNewSubject: false,
      payload: '',
      tagSelected: []
    }
  },
  watch: {
    assignment_type () {
      this.assignment_type_hint =
        this.assignment_type === '2'
          ? 'coursework'
          : this.assignment_type === '3'
            ? 'report'
            : this.assignment_type === '4'
              ? 'exam'
              : 'Q&A'
      this.getPLatformId()
    }
  },
  methods: {
    selectAllText () {},
    saveAsNewAssignment () {
      console.log('New Assignment')
    },
    toggleLinkUpload (question, show) {
      question.showFileUpload = false
      console.log((question.showLinkUpload = !show))
    },
    assignmentSelect (assignment_type) {
      this.assignment_type = assignment_type
      this.questionbank_type = this.assignment_type
    },
    getPLatformId () {
      if (this.assignment_type == 'Q&A' || this.assignment_type == '1') {
        this.platform_module_id = this.QUESTION_ANSWER_PLATFORM_MODULE_ID
      } else if (
        this.assignment_type == 'Homework' ||
        this.assignment_type == '2' ||
        this.assignment_type == 'Home Work'
      ) {
        this.platform_module_id = this.HOMEWORK_PLATFORM_MODULE_ID
      } else if (
        this.assignment_type == 'Report' ||
        this.assignment_type == '3'
      ) {
        this.platform_module_id = this.REPORT_PLATFORM_MODULE_ID
      } else if (
        this.assignment_type == 'Exam' ||
        this.assignment_type == '4'
      ) {
        this.platform_module_id = this.EXAM_PLATFORM_MODULE_ID
      }

      this.getRepositoryId(this.platform_module_id)
    },
    //Function from Link Preview Component
    removeLink (removeLinkObj) {
      const question_detail = removeLinkObj.question_detail
      const link_index = removeLinkObj.link_index
      question_detail.links.splice(link_index, 1)
      if (question_detail.links.length === 0) {
        question_detail.links.push('')
        this.showLinkUpload = false
      }
    },
    downloadFile (link) {
      const a = document.createElement('a')
      a.href = link
      a.download = link.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    //File Upload Function
    switchFormByType (event) {
      const assignment_type = event.target.value
      this.assignment_type = assignment_type
      this.fileToUpload = ''

      //To show hint beneath the form header
      this.assignment_type_hint =
        this.assignment_type === '2'
          ? 'homework'
          : this.assignment_type === '3'
            ? 'report'
            : this.assignment_type === '4'
              ? 'exam'
              : 'Q&A'
    },
    closedQuestionModal () {
      this.isQuestionModal = false
    },

    setDynamicRadioTrue (dynamicOPtion, counter) {
      dynamicOPtion.forEach((ele, index) => {
        if (counter === index) {
          ele.is_answer = true
        } else {
          ele.is_answer = false
        }
      })

      // dynamicOPtion.showAnswer = true
    },
    toggleAnswer (question_detail) {
      question_detail.showAnswer = !question_detail.showAnswer
      //
    },
    setShowAnswerFalse (question_detail) {
      question_detail.showAnswer = false
    },
    addnewOptions (question_detail) {
      question_detail.option.push({
        option_name: `option${question_detail.option.length + 1}`,
        is_answer: false,
        ordering: ''
      })
    },
    addAnotherLink (question_detail) {
      question_detail.links.push('')
    },
    duplicate (duplicateValue, index) {
      const option = this._.cloneDeep(duplicateValue.option) //cloning object
      const file_id = this._.cloneDeep(duplicateValue.file_id)
      const links = this._.cloneDeep(duplicateValue.links)

      this.question_details.splice(index, 0, {
        id: null,
        input_type_id_obj: duplicateValue.input_type_id_obj,
        question_title: duplicateValue.question_title,
        answerfeedback: duplicateValue.answerfeedback,
        answer: duplicateValue.answer,
        point: duplicateValue.point,
        option,
        showAnswer: false,
        file_id,
        links,
        showFileUpload: false,
        showLinkUpload: false,
        acceptedfileUploadType: 'image/*',
        fileUploadHelpText: 'Choose Image files'
      })
      this.$vs.notify({
        title: 'Success',
        text: 'Duplicate created successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 3000
      })
      //   this.question_detail(duplicateValue)
    },

    changeType (questionArray) {
      if (!this.assignment_id_to_edit) {
        questionArray.option.length = 0

        if (
          questionArray.input_type_id_obj.field_type === 'radio' ||
          questionArray.input_type_id_obj.field_type === 'select' ||
          questionArray.input_type_id_obj.field_type === 'checkbox' ||
          questionArray.input_type_id_obj.field_type === 'multiselect'
        ) {
          const obj = {
            option_name: 'option1',
            is_answer: false,
            ordering: ''
          }

          questionArray.option.push(obj)
        } else {
          questionArray.option = []
        }
      }
    },

    addNewQuestionForm () {
      this.question_details.push({
        id: null,
        input_type_id_obj: this.input_field_type[0],
        question_title: '',
        answerfeedback: '',
        answer: '',
        marks: '',
        point: '',
        option: [
          {
            option_name: 'option1',
            is_answer: false,
            ordering: ''
          }
        ],
        file_id: [],
        files: [],
        filesInfo: [],
        links: [''],
        showAnswer: false,
        showFileUpload: false,
        showLinkUpload: false,
        acceptedfileUploadType: 'image/*',
        fileUploadHelpText: 'Choose Image files'
        //only if it is selection,checkbox
      })
    },

    deleteQuestionById (id, index) {
      if (this.question_details.length < 2) {
        this.$vs.notify({
          title: 'Warning',
          text: 'You have to keep atleast one Question before saving',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.deleteAssignmentQuestion(id, index)
      }
    },
    async deleteAssignmentQuestion (id, index) {
      try {
        const customer_id = this.$store.getters.customerId
        const assignment_id = this.assignment_id_to_edit

        const data = await deleteAssignmentQuestion(
          customer_id,
          assignment_id,
          id
        )

        this.$vs.notify({
          title: 'success',
          text: 'Question is deleted from the assignment',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 2000
        })
        this.question_details.splice(index, 1)
      } catch (error) {}
    },
    deleteQuestion (index) {
      if (this.question_details.length < 2) {
        this.$vs.notify({
          title: 'Warning',
          text: 'You have to keep atleast one Question before saving',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.question_details.splice(index, 1)
      }
    },
    removeOption (question_detail, counter) {
      if (question_detail.option.length < 2) {
        this.showSuccessMessage(
          'Warning',
          'You have to keep atleast one option',
          'danger'
        )
      } else {
        question_detail.option.splice(counter, 1)
      }
    },
    allSub (data) {
      this.has_all_subject = data
    },
    saveQuestion (saveAs = false) {
      const hasCheckingEveryOptionAnswerDone = this.checkingOptionAnswerDone()

      const validateParent = this.$validator.validateAll('Questions')

      const childSubjectComponent =
        this.$refs.childSubjectComponent.$validator.validateAll('Questions')

      const validateAll = Promise.all([validateParent, childSubjectComponent])
      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          const { question_section_title, question_section_description } =
            this.assignment_header_info
          if (
            (this.getFormName !== 'Question & Answer' &&
              question_section_title !== '') ||
            (this.getFormName === 'Question & Answer' &&
              question_section_title === '')
          ) {
            if (hasCheckingEveryOptionAnswerDone) {
              const subjects = []
              this.subject_id.forEach((sub) => {
                subjects.push(sub.id)
              })
              const payloadObject = {
                subjects: this.has_all_subject ? [] : subjects,
                has_all_subject: this.has_all_subject,
                questionbank_type: this.questionbank_type,
                question_section_title,
                question_section_description,
                question_details: this.question_details
              }
              this.payload = payloadObject

              payloadObject.question_details.forEach((element, index) => {
                if (
                  element.input_type_id_obj.field_type === 'short-answer' ||
                  element.input_type_id_obj.field_type === 'paragraph' ||
                  element.input_type_id_obj.field_type === 'fileupload'
                ) {
                  element.option.length = 0
                  element.input_type_id = element.input_type_id_obj.id
                } else {
                  element.input_type_id = element.input_type_id_obj.id
                }

                if (
                  element.input_type_id_obj.field_type === 'fileupload' &&
                  parseInt(this.assignment_type) === 3
                ) {
                  this.showSuccessMessage(
                    'Error',
                    'Reports cannot have file upload input',
                    'danger'
                  )
                  return
                }

                element.ordering = index + 1
                if (element.option.length > 0) {
                  element.option.forEach((ele, ind) => {
                    ele['ordering'] = ind + 1
                  })
                }
              })
              //question_type check

              if (saveAs) {
                payloadObject.question_details.forEach((ele) => {
                  ele.id = null
                  console.log(ele)
                  ele.files.forEach((eachFile) => {
                    eachFile.assignment_question_id = null
                  })
                })
              }

              if (this.questionbank_type === 1) {
                this.createQuestionBank(payloadObject, saveAs)
              } else {
                this.createQuestion(payloadObject, saveAs)
              }
            } else {
              this.showSuccessMessage(
                'Error',
                'Please answer all questions which are mandatory',
                'danger'
              )
            }
          } else {
            this.showSuccessMessage(
              'Error',
              'Please add the title here',
              'danger'
            )
          }
        } else {
          this.showSuccessMessage('Error', 'Validation Are Required', 'danger')
        }
      })
    },
    async createQuestion (payload, saveAs = false) {
      this.$vs.loading()
      try {
        const customer_id = this.$store.getters.customerId
        payload.custom = 0

        if (this.$route.params.assignmentApplicationType === 'General') {
          payload.custom = 0
        }

        if (this.$route.params.assignmentApplicationType === 'Custom') {
          payload.custom = 1
        }

        if (this.assignment_id_to_edit && !saveAs) {
          let assignment_id = this.assignment_id_to_edit

          //adding custom
          if (this.$route.params.assignmentApplicationType === 'Shared') {
            payload.custom = 1
            assignment_id = null
            payload.question_details.forEach((eachPayload) => {
              eachPayload.id = null
            })
          }

          //adding custom
          const data = await editAssignment(
            payload,
            customer_id,
            assignment_id
          )
          const response = data.data.message
          this.$validator.reset()

          if (response === 'New Assignment Created Successfully') {
            this.$vs.notify({
              title: 'Success',
              text: 'Updated Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 3000
            })
          } else {
            this.$vs.notify({
              title: 'Danger',
              text: 'Ops something went wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 3000
            })
          }
        } else {
          const data = await createAssignment(payload, customer_id)
          const response = data.data.message
          this.setInitDefaultArray()

          this.questionbank_type = this.assignment_type

          if (response === 'New Assignment Created Successfully') {
            this.$vs.notify({
              title: 'Success',
              text: 'Created Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 3000
            })
            //this.$router.go(this.$router.currentRoute)
          } else {
            this.$vs.notify({
              title: 'Danger',
              text: 'Ops something went wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 3000
            })
          }
        }
      } catch (error) {
      } finally {
        this.$vs.loading.close()
      }
    },
    closedBank (obj) {
      setTimeout(() => {
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].links.length > 0) {
            this.showLinkUpload = true
          }
          obj[i].links =
            obj[i].links.length > 0
              ? obj[i].links.map((url) => {
                return url.url
              })
              : ['']
          this.question_details.push(obj[i])
        }
        this.isQuestionModal = false
      }, 1000)
    },

    async createQuestionBank (payload, saveAs = false) {
      try {
        this.$vs.loading()
        payload.custom = 0

        payload.tag_ids = [...this.tagSelected]
        payload.platform_module_id = 43

        if (this.$route.params.assignmentApplicationType === 'General') {
          payload.custom = 0
          payload.question_details.forEach((eachPayload) => {
            eachPayload.custom = 0
          })
        }

        if (this.$route.params.assignmentApplicationType === 'Custom') {
          payload.question_details.forEach((eachPayload) => {
            eachPayload.id = null
            eachPayload.custom = 1
          })
        }

        const customer_id = this.$store.getters.customerId
        if (this.assignment_id_to_edit && !saveAs) {
          let assignment_id = this.assignment_id_to_edit

          if (this.$route.params.assignmentApplicationType === 'Shared') {
            assignment_id = null
            payload.question_details.forEach((eachPayload) => {
              eachPayload.id = null
              eachPayload.custom = 1
            })
          }

          payload.id = assignment_id
          const data = await editQuestionBank(payload, customer_id)
          const response = data.data.message
          if (response === 'New question created successfully') {
            this.$vs.notify({
              title: 'Success',
              text: 'Updated Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 3000
            })
            //this.$router.go(this.$router.currentRoute)
          } else {
            this.$vs.notify({
              title: 'Danger',
              text: 'Ops something went wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 3000
            })
          }
        } else {
          //
          const data = await createQuestionBank(payload, customer_id)
          const response = data.data.message
          this.setInitDefaultArray()
       
          this.errors.clear()

          if (response === 'New question created successfully') {
            this.$vs.notify({
              title: 'Success',
              text: 'Created Successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
              time: 3000
            })
            //this.$router.go(this.$router.currentRoute)
          } else {
            this.$vs.notify({
              title: 'Danger',
              text: 'Ops something went wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              time: 3000
            })
          }
        }
      } catch (error) {
      } finally {
        this.$vs.loading.close()
      }
    },
    getIdFile (obj) {
      if (Array.isArray(obj.file_id)) {
        const file_id = obj.file_id.map((ele) => {
          return {
            id: ele,
            attachement: false
          }
        })

        this.question_details[obj.question_index].file_id.push(...file_id)
      } else {
        this.question_details[obj.question_index].file_id.push({
          id: obj.file_id,
          attachement: false
        })
      }

      /*
       */
    },
    deletedIndex (fileObject) {
      this.question_details[fileObject.question_detail_index].filesInfo.splice(
        fileObject.fileIndex,
        1
      )
      this.question_details[fileObject.question_detail_index].files.splice(
        fileObject.fileIndex,
        1
      )
      this.question_details[fileObject.question_detail_index].file_id.splice(
        fileObject.fileIndex,
        1
      )
    }
  }
}
</script>

<style>
.cstm-wrapping {
  width: 60%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
}
.cstm-card {
  border-top: 4px solid rgba(var(--vs-primary), 1);
}
.cstm-select {
  border-radius: 4px;
  padding: 10px;
  min-height: 32px;
}
.options-holder .con-vs-radio,
.options-holder .vs-radio--label,
.options-holder .con-slot-label {
  width: 100%;
}
.cls-1,
.cls-2 {
  fill: none;
  stroke: #696c72;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
.cls-1 {
  stroke-linejoin: round;
}
.cls-2 {
  stroke-miterlimit: 10;
}
.fixed-actionbar {
  position: absolute;
  bottom: 40px;
  right: -70px;
  padding: 0 20px;
  background-color: #fff;
  -webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  transition: all 0.5s ease;
}
.fixed-actionbar a {
  padding: 10px 0;
}
.fixed-actionbar a:not(:first-child) {
  border-top: 1px solid #e2e4e6;
}
.fixed-actionbar svg {
  width: 18px;
  height: 18px;
  fill: #696c72;
  opacity: 0.85;
}
.flip-svg {
  transform: scaleX(-1);
}
.wrapping_holder svg {
  width: 18px;
  height: 18px;
}
.cstm-primary-anchor {
  display: inline-flex;
  align-items: center;
  background-color: #def7d8;
  color: #000;
  padding: 10px;
  border-radius: 6px;
}
.cstm-primary-anchor:hover {
  color: #000;
}
.cstm-primary-anchor svg * {
  stroke: #000;
}
.wrapping_holder .num-holder {
  display: inline-block;
  color: #000;
  padding: 5px 20px;
  border: 1px solid #9da1a9;
  border-radius: 30px;
  margin-left: 10px;
}
.cstm-action-holder {
  display: inline-block;
  background-color: #eff1f3;
  padding: 6px 12px;
  border-radius: 30px;
}
.cstm-action-holder a {
  margin: 0 10px;
}
.num-inp {
  width: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem;
  border-radius: 5px;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.textcolorwhite {
  color: success;
}
.vs-checkbox--input:disabled + .vs-checkbox {
  opacity: 1;
}

.fileUpload-image {
  max-width: 200px;
  box-shadow: 0px 0px 3px #b8b3b385;
  border-radius: 4px;
}

.option-tooltip {
  display: inline-block;
}
.vs-input-number-primary button {
  background: #1f74ff;
}

.links-close-btn {
  float: right !important;
  margin-top: -10px;
}

.links-video {
  width: 100%;
  min-height: 250px;
}

.vs__dropdown-option--disabled {
  display: none;
}

@media only screen and (max-width: 700px) {
  .cstm-wrapping {
    width: 90%;
  }
}
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  /* background-color: #eef1f6;
  border-color: #d1dbe5; */
}
</style>
